<template>
  <gw-entity-filter-item class="a7-cidade-filter-item"
    :display-text="displayText" :property-name="propertyName"
    representation-field="nome"
    :search="finderCidade" :minimum-pattern-length="1" :find-values="finderCidadeByIDs"
    :selection-support="A7CidadeListing">
    <div slot="item" slot-scope="{entity}">
      <b>{{$t('Cidade.ui.filterItem.nome')}} </b>{{entity.nome}}<br/>
      <b>{{$t('Cidade.ui.filterItem.sigla')}} </b>{{entity.sigla}}<br/>
      <b>{{$t('Cidade.ui.filterItem.codigoIBGE')}} </b>{{entity.codigoIBGE}}
    </div>
  </gw-entity-filter-item>
</template>

<script>
import { GwEntityFilterItem, GwCustomFilterItemMixin } from 'guaxinim-web'
import CidadeRestResource from './CidadeRestResource'
import A7CidadeListing from './A7CidadeListing'

export default {
  name: 'a7-cidade-filter-item',
  mixins: [GwCustomFilterItemMixin],
  components: {
    GwEntityFilterItem
  },
  data() {
    return {
      A7CidadeListing : A7CidadeListing
    }
  },
  methods: {
    finderCidade(pattern) {
      if (!pattern) return null
      return CidadeRestResource.findCidadeFinderDTO(null, pattern, 10)
    },
    finderCidadeByIDs(ids) {
      return CidadeRestResource.findCidadeFinderDTO(ids)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>